import { useAssets } from './assets-context';
export var useAssetSpritesheet = function (key) {
    var spritesheets = useAssets().spritesheets;
    return spritesheets[key];
};
export var useAssetMap = function (key) {
    var maps = useAssets().maps;
    return maps[key];
};
